import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
export class FormlyFieldInput extends FieldType {
/**
 * @return {?}
 */
get type() {
    return this.to.type || 'text';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-field-input',
  template: `
    <input [type]="type" [formControl]="formControl" class="form-control"
      [formlyAttributes]="field" [class.is-invalid]="showError">
    `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyFieldInput_tsickle_Closure_declarations() {
/** @type {?} */
FormlyFieldInput.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyFieldInput.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
